module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/TAyGhA/tc-custom/9780369700407.jpg?1699985077175",
      "alt": "This image is the cover for the book Puppy's Tale"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Puppy's Tale\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Fall in love with this fan-favorite novella of family, romance and dogs from author Valerie Hansen.")]), _c('br'), _c('br'), _vm._v("Single mom Krista Brody has no problem walking up to a neighbour’s door while searching for her son’s runaway puppy, Puddles. But the stranger who opens the door is very familiar…"), _c('br'), _c('br'), _vm._v("Mark Vanbruger hasn’t seen Krista in years, but now they’re living in the same small town. They missed a chance at romance years ago—could a matchmaking puppy help them find happiness as a family now?"), _c('br'), _c('br'), _c('i', [_vm._v("Originally published in 2003.")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Valerie Hansen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Valerie Hansen resides in the rural Ozarks where she writes the books of her heart, primarily for Love Inspired Romance and Suspense. She is married to her childhood sweetheart and has worked as a teacher's-aide, EMT, fire dept. dispatcher, dog breeder, commercial artist, dulcimer builder, Veterinarian's asst., 4-H leader, Sunday School teacher, antique restorer and certified Storm Spotter, etc. See ValerieHansen.com for more!")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises Limited\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0